// Карточки сводки «Загрузки кухни» — те же MetricCard, что на «Выручке» и «Себестоимости».
// Итоги по общему правилу модели: закрытые + открытые (для периода с сегодня, не «в среднем за день»),
// открытая часть — подписью «из них N в открытых».
import React from 'react';
import { Box } from '@mui/material';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';
import MetricCard from '../../Metrics/components/MetricCard';
import { KPI_COLORS, SECTION_ACCENTS } from '../../../styles/tokens';
import { formatInt as integer, formatMoney } from '../kitchenFormat';

export default function KitchenSummary({ model, perDay, loading }) {
  const totals = model?.totals || { items: 0, orders: 0, sum: 0 };
  const open = model?.openTotals || { items: 0, orders: 0, sum: 0 };
  const peak = model?.peak;
  const suffix = perDay ? ' в день' : '';
  const note = (value, text) => (value > 0 ? `из них ${text} в открытых` : null);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(4, minmax(0, 1fr))' },
        gap: { xs: 1.5, md: 2 },
        width: '100%',
        alignItems: 'stretch',
      }}
    >
      <MetricCard
        icon={SoupKitchenIcon}
        title={`Позиций на кухню${suffix}`}
        valueNumber={totals.items}
        format={integer}
        note={note(open.items, integer(open.items))}
        color={SECTION_ACCENTS['/kitchen'].accent}
        loading={loading}
      />
      <MetricCard
        icon={ReceiptLongIcon}
        title={`Заказов с кухней${suffix}`}
        valueNumber={totals.orders}
        format={integer}
        note={note(open.orders, integer(open.orders))}
        color={KPI_COLORS.ordersCount}
        loading={loading}
      />
      <MetricCard
        icon={CurrencyRubleIcon}
        title={`Сумма кухни${suffix}`}
        valueNumber={totals.sum}
        format={(n) => `${integer(n)} `}
        suffix="₽"
        note={note(open.sum, formatMoney(open.sum))}
        color={KPI_COLORS.revenueMain}
        loading={loading}
      />
      <MetricCard
        icon={ScheduleIcon}
        // Позиции — в заголовке: справа от заголовка стоит иконка, на телефоне подпись наезжала на неё
        title={peak ? `Пиковый час · ${integer(peak.items)} поз.` : 'Пиковый час'}
        value={peak ? peak.label : '—'}
        raw
        note={peak && peak.openItems > 0 ? `из них ${integer(peak.openItems)} в открытых` : null}
        color={KPI_COLORS.discountSum}
        loading={loading}
      />
    </Box>
  );
}
